<template>
	<v-dialog persistent max-width="764px" ref="createDialog" v-model="dialog">
		<v-form lazy-validation ref="form" v-model="valid">
			<v-card>
				<v-card-title>
					<span class="text-h5">Create Outlet</span>
				</v-card-title>
				<v-card-text>
					<v-row>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="errors && errors.message">
                            <v-alert dense outlined type="error" class="mb-0"><span v-text="errors.message"></span></v-alert>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <v-autocomplete dense clearable label="Address*" :disabled="loading" :rules="rules.address" :items="addresses" :error-messages="errors.address" @change="updateOutlet" v-model="object.address"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field dense clearable label="Name*" :disabled="loading" :rules="rules.name" :error-messages="errors.name" v-model="object.name"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field dense clearable label="Unit No.*" :disabled="loading" :error-messages="errors.unit_number" v-model="object.unit_number"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field dense clearable label="Latitude*" :disabled="loading" :rules="rules.latitude" :error-messages="errors.latitude" v-model="object.latitude"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field dense clearable label="Longitude*" :disabled="loading" :rules="rules.longitude" :error-messages="errors.longitude" v-model="object.longitude"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field dense clearable label="Person In Charge" :disabled="loading" :error-messages="errors.contact_person" v-model="object.contact_person"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field dense clearable label="Contact Number" :disabled="loading" :error-messages="errors.contact_number" v-model="object.contact_number"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <small class="red--text">* Required field</small>
                        </v-col>
                    </v-row>
				</v-card-text>
				<v-card-actions class="pl-4 pr-4">
					<v-spacer></v-spacer>
					<v-btn text @click="close">Close</v-btn>
					<v-btn text color="primary" :loading="loading" @click="create">Create</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>


<script>

import { copyObject } from '@/utils/helper'

export default {
	name: 'OutletCreateDialog',
	props: {
        addresses: {
            type: Array,
            required: false,
            default: () => []
        }
	},
	data() {
		return {
			dialog: false,
			valid: true,
			loading: false,
			object: {
                address: '',
                name: '',
                unit_number: '',
                latitude: '',
                longitude: '',
                contact_person: '',
                contact_number: ''
			},
			rules: {
                address: [
                    (value) => !!value || 'Address is required'
                ],
                name: [
                    (value) => !!value || 'Name is required'
                ],
                unit_number: [
                    (value) => !!value || 'Unit number is required'
                ],
                latitude: [
                    (value) => {
                        if(!value) {
                            return 'Latitude is required'
                        }

                        if(isNaN(value)) {
                            return 'Latitude must a numeric value'
                        }

                        return true
                    }
                ],
                longitude: [
                    (value) => {
                        if(!value) {
                            return 'Longitude is required'
                        }

                        if(isNaN(value)) {
                            return 'Longitude must a numeric value'
                        }

                        return true
                    }
                ]
            },
			errors: {}
		}
	},
	computed: {
		createDialog() {
			return this.$refs.createDialog
		},
		form() {
			return this.$refs.form
		}
	},
	methods: {
		open: function() {
			this.dialog = true
		},
		close: function() {
            this.dialog = false
			this.loading = false
            this.object = { address: '', name: '', unit_number: '', latitude: '', longitude: '', contact_person: '',
                            contact_number: '' }
			this.errors = {}
			this.form.resetValidation()
		},
		create: function() {
			if(this.form.validate()){
				this.loading = true
                const object = copyObject(this.object)

				this.$store.dispatch('epanel/outlet/createChainOutlet', { id: this.$route.params.id, object: object}).then((response) => {
                    this.close()
                    this.$emit('created', { message: response.message })
                }).catch((errors) => {
                    this.errors = errors.data?errors.data.errors:errors
                    this.loading = false
                })
			}
		},
		updateOutlet: function() {
            const address = this.addresses.filter((item) => item.value === this.object.address)
            if(address.length > 0){
                this.object.name = address[0].name?address[0].name:''
                this.object.latitude = address[0].latitude?address[0].latitude:''
                this.object.longitude = address[0].longitude?address[0].longitude:''
            }
		}
	}
}

</script>